<p-tabs [value]="tabvalue">
    <p-tablist>
        <p-tab value="account">Account</p-tab>    
        <p-tab value="user">User Management</p-tab>
        <p-tab value="organization">Organization</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="account">
   
            <!-- container --> 
            <app-account></app-account>
            
        </p-tabpanel>
        <p-tabpanel value="user">
   
            <!-- container --> 
            <app-users></app-users>
            
        </p-tabpanel>      
        <p-tabpanel value="organization">
   
            <!-- container --> 
            <app-list-organization></app-list-organization>
            
        </p-tabpanel>        
 
    </p-tabpanels>
</p-tabs>